<template>
    <Modal
        v-model="visible"
        title="导入"
        :loading="formModalLoading"
        @on-ok="submit"
        @on-cancel="cancel">
         <Form ref="formModal" :model="formValidate" :rules="ruleValidate" :label-width="80">
            <FormItem label="文件" prop="url">
                <Upload 
                    ref="upload"
                    :show-upload-list="false"
                    :action="uploadUrl"
                    :data="uploadPram"
                    :before-upload="beforeUpload"
                    :on-success="onSuccess"
                    :on-error="onError"
                    :max-size="20480000"
                    :headers='{"token": $sessionToken()}'
                    >
                    <Button icon="ios-cloud-upload-outline" :loading="uploading">{{fileName}}</Button>
                </Upload>
            </FormItem>
            <FormItem label="生效时间" prop="yearMonth">
                <DatePicker 
                type="month" 
                placeholder="请选择生效时间" 
                @on-change="timeChange"
                format="yyyyMM"
                class="public-inp"
                ></DatePicker>
            </FormItem>
            <FormItem label="备注">
                 <Input v-model="formValidate.remark" 
                 :maxlength="100" 
                 show-word-limit 
                 clearable
                 :autosize="{minRows: 2,maxRows: 5}"
                 type="textarea" 
                 placeholder="请输入备注" 
                 style="width: 300px" />
            </FormItem>
        </Form>
    </Modal>
</template>
<script>
    import axios from "axios";
    export default {
        props:{
            visiable: {
                type: Boolean,
            },
            templateFileType: {
                type: String
            }
        },
        data () {
            return {
                visible:false,
                fileName:'上传Excel',
                formModalLoading:true,
                formValidate: {
                    fileId:'',
                    fileName:'',
                    url:'',
                    yearMonth:'',
                    remark:''
                },
                ruleValidate: {
                    url: [
                        { required: true, message: '请上传文件', trigger: 'blur' }
                    ],
                    yearMonth: [
                        { required: true, message: '请选择生效时间', trigger: 'blur' }
                    ],
                },
                uploadUrl:'',
                uploadPram:{
                    fileType: ''
                },
                uploading:false,
            }
        },
        created(){
          this.uploadUrl = axios.defaults.baseURL + 'base/template/uploadFile';
          this.uploadPram.fileType = this.templateFileType;
        },
        watch:{
            visiable(val){
                this.visible = val;
            }
        },
        methods:{
            beforeUpload(d){
                let types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel'];
                if(types.indexOf(d.type) == -1){
                    this.$Message.error('请上传Excel文件');
                    return false;
                }
                this.uploading = true;
                this.fileName = d.name;
            },
            onSuccess(response, file, fileList){
                this.uploading = false;
                if(response.code=='200'){
                    this.formValidate.fileId = response.data.fileId;
                    this.formValidate.fileName = this.fileName;
                    this.formValidate.url = response.data.url;
                }else{
                    this.$Message.error(response.message);
                }
            },
            onError(){
                this.fileName = '上传Excel';
                Object.keys(this.formValidate).forEach(i=>{
                    this.formValidate[i] = '';
                });
                this.uploading = false;
                this.$Message.error('上传失败');
            },
            timeChange(v){
                this.formValidate.yearMonth = v;
            },
            submit(){
                let data = this.formValidate;
                data.templateFileType = this.templateFileType;
                this.formModalLoading = false;
                this.$nextTick(() => {
                    this.formModalLoading = true;
                });
                this.$refs['formModal'].validate((valid) => {
                    if (valid) {
                        this.$api.allocImport(data).then(res=>{
                            if(res.code=='200'){
                                this.$Message.success(res.message);
                                this.$emit("reloadList");
                                this.cancel();
                            }
                        })
                    }
                })
            },
            cancel(){
                this.fileName = '上传Excel';
                this.$refs['formModal'].resetFields();
                this.$emit("uploadToggle");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/quota/allocImport.vue